module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"818.103 321.188 177.146 176.265\"><path d=\"M986.932 330.9c-1.555-1.975-3.938-3.13-6.464-3.13h-81.99c-2.176 0-4.262.857-5.798 2.384l-65.593 65.1c-1.54 1.524-2.402 3.594-2.402 5.753v81.375c0 4.495 3.67 8.138 8.2 8.138H964.07c4.53 0 8.2-3.643 8.2-8.138v-80.375l16.15-64.13c.614-2.428.065-5.002-1.488-6.977zM964.07 482.383H832.884v-73.238H964.07v73.238zm0-81.375H832.884l65.593-65.1h81.99l-16.397 65.1z\"></path><path d=\"M931.274 417.283h24.597v8.138h-24.596z\"></path></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarHire/images/FeatureDoors.svg
 ** module id = 1350
 ** module chunks = 1
 **/